var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "salutation-select__wrapper" }, [
    _c("div", { staticClass: "select-checkout__wrapper" }, [
      _c(
        "select",
        {
          attrs: {
            title: _vm.$translate("ODNaPo::NaPo.checkoutSalutationSelect"),
            id: _vm._uid + _vm.addressType,
          },
          domProps: { value: _vm.addressData.gender },
          on: {
            change: function ($event) {
              return _vm.emitInputEvent($event.target.value)
            },
          },
        },
        _vm._l(_vm.currentSalutation, function (salutation, index) {
          return _c(
            "option",
            {
              domProps: {
                value: salutation.key,
                selected:
                  _vm.addressData.gender === _vm.currentSalutation &&
                  _vm.checkGenderCompany(salutation.key),
              },
            },
            [
              _vm._v(
                "\n                " +
                  _vm._s(salutation.name) +
                  "\n            "
              ),
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c("label", { attrs: { for: _vm._uid + _vm.addressType } }, [
        _vm._v(
          "\n            " +
            _vm._s(_vm.$translate("ODNaPo::NaPo.checkoutSalutationSelect")) +
            "\n        "
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }